export default class IAuth {
    constructor() {
    }

    async login(login, password) { throw new Error("Not implemented") }
    async logout(token) { throw new Error("Not implemented") }
    async changeRole(employeeId, roleId, configuratorMode) { throw new Error("Not implemented") }
}